interface Styles {
  [key: string]: string;
}

export const flattenStyles =
  (styles: Styles) =>
  (appearance: string[] | string | undefined): { [key: string]: boolean } | string | undefined => {
    if (appearance === undefined) {
      return;
    }
    if (Array.isArray(appearance)) {
      return appearance.reduce((a, i) => (styles[i] ? { ...a, [styles[i]]: true } : a), {});
    }
    return styles[appearance];
  };
